(() => {
  "use strict";

  const root = document.querySelector("[data-storyled-guide]");
  if (!root) return;

  const body = root.querySelector("[data-storyled-guide-body]");
  const toc = root.querySelector("[data-storyled-guide-toc]");
  const reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (!body) return;

  const progress = document.createElement("div");
  const progressFill = document.createElement("span");
  progress.className = "storyled-reading-progress";
  progress.setAttribute("aria-hidden", "true");
  progress.appendChild(progressFill);
  document.body.appendChild(progress);

  const headings = Array.from(body.querySelectorAll("h2"));
  headings.forEach((heading, index) => {
    if (!heading.id) heading.id = "storyled-guide-" + (index + 1);
    if (!toc) return;
    const item = document.createElement("li");
    const link = document.createElement("a");
    link.href = "#" + heading.id;
    link.textContent = heading.textContent.trim();
    item.appendChild(link);
    toc.appendChild(item);
  });

  const comparison = body.querySelector("table");
  if (comparison) {
    const wrap = document.createElement("div");
    wrap.className = "storyled-guide__table-wrap";
    comparison.parentNode.insertBefore(wrap, comparison);
    wrap.appendChild(comparison);

    const rows = Array.from(comparison.querySelectorAll("tbody tr"));
    rows.forEach((row) => row.classList.add("storyled-guide__table-row"));

    const choice = document.createElement("section");
    choice.className = "storyled-guide__choice";
    choice.setAttribute("aria-label", "Conseil produit");
    const copy = document.createElement("p");
    copy.innerHTML = "<strong>Vous utilisez surtout une console, une Apple TV ou une box HDMI ?</strong><br>La Sync Box HDMI 2.0 garde votre installation nette et vos couleurs stables.";
    const link = document.createElement("a");
    link.className = "storyled-guide__button";
    link.href = "/products/storyled-sync-box";
    link.textContent = "Voir la Sync Box";
    choice.append(copy, link);
    wrap.after(choice);
  }

  const productLinks = Array.from(body.querySelectorAll('a[href*="/products/storyled-sync-box"]'));
  productLinks.forEach((productLink) => {
    productLink.classList.add("storyled-guide__button");
    productLink.setAttribute("aria-label", "Découvrir la Sync Box HDMI 2.0 STORYLED");
  });

  const revealTargets = Array.from(body.querySelectorAll("h2, h3, p, ul, ol, .storyled-guide__table-wrap, .storyled-guide__choice"));
  revealTargets.forEach((node) => node.setAttribute("data-storyled-reveal", ""));

  const showAll = () => {
    root.querySelectorAll("[data-storyled-reveal], .storyled-guide__table-row").forEach((node) => node.classList.add("is-visible"));
  };

  if (!reduceMotion && "IntersectionObserver" in window) {
    const observer = new IntersectionObserver((entries, instance) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-visible");
        instance.unobserve(entry.target);
      });
    }, { rootMargin: "0px 0px -9% 0px", threshold: 0.08 });

    root.querySelectorAll("[data-storyled-reveal], .storyled-guide__table-row").forEach((node) => observer.observe(node));
  } else {
    showAll();
  }

  let queued = false;
  const updateProgress = () => {
    const top = window.scrollY || window.pageYOffset;
    const range = Math.max(document.documentElement.scrollHeight - window.innerHeight, 1);
    const value = Math.max(0, Math.min(1, top / range));
    progressFill.style.transform = "scaleX(" + value + ")";
    queued = false;
  };
  const requestProgress = () => {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(updateProgress);
  };

  updateProgress();
  window.addEventListener("scroll", requestProgress, { passive: true });
  window.addEventListener("resize", requestProgress, { passive: true });
})();